import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Headline from 'components/Headline/Headline';
import Loader from 'components/Loader/Loader';
import ActivateToggle from 'components/ActivateToggle/ActivateToggle';
import { KeyValueDTO } from 'generated/models/KeyValueDTO';
import { KeyValueStoreService } from 'generated/services/KeyValueStoreService';
import useAppStatus from 'hooks/useAppStatus';
import { setKeyValueStoreItem } from 'redux/slices/kvstore/kvstoreSlice';

const ToggleDiscount = () => {
  const [showDiscount, setShowDiscount] = useState<boolean | undefined>(
    undefined,
  );
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation(['translation', 'settings']);
  const { setAppStatus } = useAppStatus();

  const getValue = async (): Promise<boolean> => {
    try {
      const keyValueDto = await KeyValueStoreService.getKeyValueStoreItem(
        KeyValueDTO.key.ENABLE_DISCOUNT_PRICES,
      );

      return keyValueDto.value === 'true';
    } catch (error) {
      return false;
    }
  };

  const setValue = async (): Promise<void> => {
    setLoading(true);
    try {
      setKeyValueStoreItem({
        key: KeyValueDTO.key.ENABLE_DISCOUNT_PRICES,
        value: showDiscount ? 'false' : 'true',
      });
      const keyValueDto = await KeyValueStoreService.setKeyValueStoreItem({
        key: KeyValueDTO.key.ENABLE_DISCOUNT_PRICES,
        value: showDiscount ? 'false' : 'true',
      });
      setShowDiscount(keyValueDto.value === 'true');
    } catch (error) {
      setShowDiscount(false);
      setAppStatus(t('settings:toggle-enable-discount.error'), 'error');
    }
    setLoading(false);
  };

  useEffect(() => {
    getValue().then((_showDiscount) => setShowDiscount(_showDiscount));
  }, []);

  return (
    <div>
      <Headline className="settings__headline" headingLevel="h2" size={2}>
        {t('settings:toggle-enable-discount.headline')}
      </Headline>

      <p className="settings__block page__form-desc">
        {t('settings:toggle-enable-discount.description')}
      </p>

      {showDiscount === undefined ? (
        <Loader />
      ) : (
        <div>
          <label id="statistic-discount-toggle-desc" className="input__label">
            {t('edit')}
          </label>

          <ActivateToggle
            active={showDiscount}
            onToggle={setValue}
            ariaDescribedBy="#statistic-discount-toggle-desc"
            loading={loading}
            activeIcon="eye"
            inactiveIcon="eye-off"
          />
        </div>
      )}
    </div>
  );
};

export default ToggleDiscount;
